module.exports = __webpack_public_path__ + "static/media/up.725898f3.svg";